// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A single global pre-release grant — the organization sees every supported-but-unavailable region.
 * @export
 * @interface GlobalPreRelease
 */
export interface GlobalPreRelease {
  /**
   *
   * @type {string}
   * @memberof GlobalPreRelease
   */
  note?: string;
  /**
   *
   * @type {string}
   * @memberof GlobalPreRelease
   */
  createdBy: string;
  /**
   *
   * @type {Date}
   * @memberof GlobalPreRelease
   */
  createdAt: Date;
}

/**
 * Check if a given object implements the GlobalPreRelease interface.
 */
export function instanceOfGlobalPreRelease(
  value: object,
): value is GlobalPreRelease {
  if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
  return true;
}

export function GlobalPreReleaseFromJSON(json: any): GlobalPreRelease {
  return GlobalPreReleaseFromJSONTyped(json, false);
}

export function GlobalPreReleaseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GlobalPreRelease {
  if (json == null) {
    return json;
  }
  return {
    note: json['note'] == null ? undefined : json['note'],
    createdBy: json['created_by'],
    createdAt: new Date(json['created_at']),
  };
}

export function GlobalPreReleaseToJSON(json: any): GlobalPreRelease {
  return GlobalPreReleaseToJSONTyped(json, false);
}

export function GlobalPreReleaseToJSONTyped(
  value?: GlobalPreRelease | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    note: value['note'],
    created_by: value['createdBy'],
    created_at: value['createdAt'].toISOString(),
  };
}
